import React from "react";
import "./NavbarComponent.css";
export function NavbarIndexComponent() {
  return (
    <>
      <header className="">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="d-flex align-items-center flex-wrap justify-content-center">
            <img className="img-icon" alt="logo" src={"../../images/logoDSD2.png"} onClick={() => window.location.href = "/"} style={{cursor:"pointer"}} />
            <div className="d-flex flex-column text-white">
              <h3>ระบบสารสนเทศกองทุนพัฒนาฝีมือแรงงาน</h3>
              <h5>กรมพัฒนาฝีมือแรงงาน</h5>
            </div>
          </div>
        </div>
      </header>



    </>
  );
}
